import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import { auth2,ref2 } from '../config/firebase2'
import {logoutUser2} from '../helpers/auth'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class AddUser extends Component {

	constructor(){
        super();
        this.createUser=this.createUser.bind(this);
        this.state = {
         userId : "",
         user : {}
        };
    }

    componentWillMount(){

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                db.on("value",function(data){

                    this.setState({
                    userId:data.key,
                    user:data.val()
                    });

                }.bind(this));
            }else{
            this.props.history.push("/");
            }
        });       
    }

    componentWillUnmount(){
        this.listener()
    } 
 
    createUser(e){
        e.preventDefault();
        const user={
            firstname : this.firstName.value,
            lastname :this.lastName.value,
            email :this.email.value,
            gender : this.gender.value,
            role : this.role.value,
            password : this.pw.value,
            image : "avatar.jpg",
            status: "Active"
        }
        if(this.pw.value === this.pw2.value){
            var email = this.email.value;
            var pass = this.pw.value;      
            var results = auth2.createUserWithEmailAndPassword(email, pass);
                results.then(function(userRecord) {
        
                    ref2.child('users/' + userRecord.uid).set(user)
                    alert("New user is added");
                    this.userForm.reset();
                    logoutUser2();
                    window.location.assign("/users")
                }.bind(this))
                results.catch(function(error) {
                    alert("Error creating new user:", error);
                })
        }else{
            alert("Password Mismatch");
        }
        
    }

    render() {
      
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content" className="forAddUser">
                            <Title title="Add User" />
                            <div className="block">
                                <form className="form-horizontal form-bordered" ref={(input) => {this.userForm=input}}  onSubmit={(e)=>this.createUser(e)}>
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">First Name</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  ref={(input) => {this.firstName=input}} type="text" required/>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Last Name</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.lastName=input}} type="text" required/>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Email Address</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.email=input}} type="email" required/>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Password</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.pw=input}} type="password" required/>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Re-Type Password</label>
                                        <div className="col-md-4">
                                            <input className="form-control" ref={(input) => {this.pw2=input}} type="password" required/>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Gender</label>
                                        <div className="col-md-4">
                                            <select className="form control select-chosen" ref={(input) => {this.gender=input}}>
                                              <option value="Male">Male</option>
                                              <option value="Female">Female</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Role</label>
                                        <div className="col-md-4">
                                            <select className="form control select-chosen"  ref={(input) => {this.role=input}}>
                                              <option value="Admin">Admin</option>
                                              <option value="Salesman">Salesman</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-group form-actions">
                                        <div className="col-md-9 col-md-offset-3">
                                            <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-user-plus"></i> Add User</button>
                                        </div>
                                    </div>
                                </form>

                                
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}
  
export default AddUser;



// WEBPACK FOOTER //
// ./src/components/AddUser.js